/**
 * ShareLinks
 */

const ShareLinks = (function($) {
  "use strict";

  function isMediumViewport() {
    return $(window).width() > 800;
  }

  /**
   * Calculate the position of the popup so it’s centered on the screen.
   */

  function windowPopup(url, width, height) {
    /* eslint-disable no-restricted-globals */
    const left = screen.width / 2 - width / 2;
    const top = screen.height / 2 - height / 2;
    /* eslint-enable no-restricted-globals */

    window.open(
      url,
      "",
      `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=${width},height=${height},top=${top},left=${left}`
    );
  }

  function enhanceShareLinks() {
    const $shareLinks = $(".ShareLinks-link");

    if (isMediumViewport()) {
      $shareLinks.on("click", function(e) {
        e.preventDefault();
        windowPopup($(this).attr("href"), 600, 400);
      });
    }
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".ShareLinks").length) {
      return;
    }

    enhanceShareLinks();
  }

  return {
    init
  };
})(jQuery);

jQuery(document).ready(ShareLinks.init);
